import React, { useEffect, useRef, useState } from 'react';
import './CareersAndCulture.scss'
import '../../../pages/styles.scss'
import Careers from '../../../../assets/images/Community/careers.png'
import tagSvg from '../../../../assets/images/WhoWeHelp/tag.svg'
import CommonInsuranceSection from '../../../../components/reusable/HomePageSections/CommonInsuranceSection/CommonInsuranceSection.js';
import FooterSection from '../../../../components/reusable/HomePageSections/FooterSection/FooterSection.js';
import { jobListingsOnCareersPage } from '../../../../components/reusable/Common/Constant.js';
import { Link } from 'react-router-dom';

const CareersAndCulture = () => {
    const [shouldScroll, setShouldScroll] = useState(false);
    const formRef = useRef(null); // Use ref to point to the form element

    const scrollToForm = () => {
        if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    useEffect(() => {
        if (shouldScroll) {
            scrollToForm();
            setShouldScroll(false);
        }
    }, [shouldScroll]);

    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }, []);
    return (
        <div className='careers-and-culture-container container'>
            <div className='careers-and-culture-section section-1'>
                <div className='careers-and-culture-section-content text'>
                    <h1>About Virginia Rehab Physicians</h1>
                    <p>We are dedicated to improving patient-centered care for individuals with functional impairments, focusing on enhancing their independence and quality of life.</p>
                    <div className='button-section'>
                        <a className='btn' onClick={(e) => {
                            e.preventDefault();
                            scrollToForm();
                        }}>
                            <i className='bx bx-plus'></i>
                            Explore Career Opportunities
                        </a>
                    </div>
                </div>
                <div className='careers-and-culture-section-content image'>
                    <div className='image-container'>
                        <img src={Careers} alt="" />
                    </div>
                </div>
            </div>
            <div className='careers-and-culture-section section-2'>
                <div className='careers-and-culture-section-content text'>
                    <div className='company-vision-title'>
                        <div className='tag' style={{
                            backgroundImage: `url(${tagSvg})`,
                        }}>
                            <span>Teamwork</span>
                        </div>
                        <br />
                        <h1>A Great Place to Work</h1>
                    </div>
                    <div className='company-vision-para'>
                        <p>Virginia Rehab Physicians offers a dynamic environment where professionals from various backgrounds collaborate to deliver exceptional care. We believe in the power of teamwork to create innovative solutions and achieve our mission. For non-patient-facing staff, we provide the flexibility of fully remote work.</p>
                    </div>
                </div>
                <hr className="section-divider" />
                <div className='careers-and-culture-section-content text'>
                    <div className='company-vision-point'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40" viewBox="0 0 41 40" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M36.5692 7.37491C38.4473 7.37491 39.9685 5.72321 39.9685 3.68746C39.9685 1.65171 38.4473 0 36.5692 0C34.6926 0 33.1699 1.65171 33.1699 3.68746C33.1699 5.72477 34.6926 7.37491 36.5692 7.37491ZM36.5938 18.1095H25.5022C23.6212 18.1095 22.0957 16.4547 22.0957 14.4143C22.0957 12.3738 23.6212 10.719 25.5022 10.719H36.5952C38.4762 10.719 40.0017 12.3738 40.0017 14.4143C40.0017 16.4547 38.4748 18.1095 36.5938 18.1095ZM14.4534 28.8144H36.5934C38.4744 28.8144 39.9999 27.1595 39.9999 25.1191C39.9999 23.0787 38.4744 21.4238 36.5934 21.4238H14.4534C12.5724 21.4238 11.0469 23.0787 11.0469 25.1191C11.0469 27.1595 12.5724 28.8144 14.4534 28.8144ZM3.40649 40.0001H36.5935C38.4745 40.0001 40 38.3453 40.0014 36.3049C40.0014 34.2644 38.4759 32.6096 36.5949 32.6096H3.40649C1.52551 32.6096 0 34.2644 0 36.3049C0 38.3453 1.52551 40.0001 3.40649 40.0001Z" fill="url(#paint0_linear)"></path><defs><linearGradient id="paint0_linear" x1="0" y1="0" x2="40" y2="51.5" gradientUnits="userSpaceOnUse"><stop stopColor="#FA9081"></stop><stop offset="1" stopColor="#FBD647"></stop></linearGradient></defs></svg>
                        <h2>Transparency</h2>
                        <p>We maintain an open environment where leadership is always available to answer questions and provide clarity on important matters.</p>
                    </div>
                    <div className='company-vision-point'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M39.9999 3.40649V36.5935C39.9999 38.4759 38.3451 40 36.3046 40C34.2642 40 32.6094 38.4745 32.6094 36.5935V3.40649C32.6094 1.52551 34.2642 0 36.3046 0C38.3451 0 39.9999 1.52551 39.9999 3.40649ZM28.8143 14.4534V36.5934C28.8143 38.4758 27.1595 39.9999 25.1191 39.9999C23.0786 39.9999 21.4238 38.4744 21.4238 36.5934V14.4534C21.4238 12.5724 23.0786 11.0469 25.1191 11.0469C27.1595 11.0469 28.8143 12.5724 28.8143 14.4534ZM18.1092 36.5935V25.5005C18.1092 23.6195 16.4544 22.094 14.414 22.094C12.3736 22.094 10.7188 23.6195 10.7188 25.5005V36.5935C10.7188 38.4745 12.3736 40 14.414 40C16.4544 40 18.1092 38.4759 18.1092 36.5935ZM7.37489 36.569C7.37489 38.4471 5.72319 39.9683 3.68744 39.9683C1.65014 39.9683 0 38.4456 0 36.569C0 34.6923 1.65014 33.1697 3.68744 33.1697C5.72475 33.1697 7.37489 34.6909 7.37489 36.569Z" fill="url(#paint0_linear)"></path><defs><linearGradient id="paint0_linear" x1="0" y1="0" x2="40.0003" y2="51.4982" gradientUnits="userSpaceOnUse"><stop stopColor="#FA9081"></stop><stop offset="1" stopColor="#FBD647"></stop></linearGradient></defs></svg>
                        <h2>Feedback-Focused</h2>
                        <p>We foster a culture of honest, ongoing feedback that encourages open dialogue between employees, managers, and executives.</p>
                    </div>
                    <div className='company-vision-point'>
                        <svg xmlns="http://www.w3.org/2000/svg" width="55" height="41" viewBox="0 0 55 41" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M5.4723 11.0005L14.5298 11.0005C17.5517 11.0005 20.0021 8.53933 20.0021 5.50153C20.0021 2.46373 17.5517 0.000488281 14.5297 0.000488281H5.4723C2.45038 0.000488281 0 2.46582 0 5.50153C0 8.53724 2.45038 11.0005 5.4723 11.0005ZM5.4723 26.0005L14.5298 26.0005C17.5517 26.0005 20.0021 23.5393 20.0021 20.5015C20.0021 17.4637 17.5517 15.0005 14.5297 15.0005L5.4723 15.0005C2.45038 15.0005 0 17.4658 0 20.5015C0 23.5372 2.45038 26.0005 5.4723 26.0005ZM34.5298 41.0005H5.4723C2.45038 41.0005 0 38.5372 0 35.5015C0 32.4658 2.45038 30.0005 5.4723 30.0005L34.5298 30.0005C37.5517 30.0005 40.0021 32.4637 40.0021 35.5015C40.0021 38.5393 37.5517 41.0005 34.5298 41.0005ZM49.5 41.0005C52.538 41.0005 55 38.5385 55 35.5005C55 32.4625 52.538 30.0005 49.5 30.0005C46.462 30.0005 44 32.4625 44 35.5005C44 38.5385 46.462 41.0005 49.5 41.0005Z" fill="url(#paint0_linear)"></path><defs><linearGradient id="paint0_linear" x1="0" y1="0.000488281" x2="36.6994" y2="63.3828" gradientUnits="userSpaceOnUse"><stop stopColor="#FA9081"></stop><stop offset="1" stopColor="#FBD647"></stop></linearGradient></defs></svg>
                        <h2>Commitment to Growth</h2>
                        <p>We are dedicated to the continuous professional development of our staff, offering regular support and guidance to help each team member achieve their career goals.</p>
                    </div>
                </div>
            </div>
            <hr className="section-divider" />
            <div className='careers-and-culture-section section-3'>
                <div className='careers-and-culture-section-content text'>
                    <h1>Are you a Physiatrist Interested in Joining Our Team? Submit Your Resume Below!</h1>
                    <div className='button-section'>
                        <Link className='btn' to={`/page-for-job-apply?jobTitle=${encodeURIComponent('Physical Medicine and Rehab Physician')}`}>
                            <i className='bx bx-plus'></i>
                            Apply Now!
                        </Link>
                    </div>
                </div>
            </div>
            <div className='careers-and-culture-section section-4'>
                <div className='careers-and-culture-section-content text'>
                    <div className='what-we-offer-title'>
                        <h1>Benefits and Perks That Make Life Better</h1>
                    </div>
                    <ul className='what-we-offer-list'>
                        <li><i className='bx bx-check'></i>A variety of comprehensive health, dental, and vision plans to choose from</li>
                        <li><i className='bx bx-check'></i>Access to group retirement 401(k) plan with employer contributions</li>
                        <li><i className='bx bx-check'></i>Generous paid time off</li>
                        <li><i className='bx bx-check'></i>Flexible work-life balance with remote work options</li>
                        <li><i className='bx bx-check'></i>Flexible scheduling, including weekend shifts</li>
                        <li><i className='bx bx-check'></i>Opportunities for overtime</li>
                        <li><i className='bx bx-check'></i>Professional development and training opportunities</li>
                        <li><i className='bx bx-check'></i>Floating coverage options available</li>
                    </ul>
                </div>
            </div>
            <div className="careers-and-culture-section section-5" ref={formRef}>
                <div className='careers-and-culture-section-content text'>
                    <h1>Our Job Listings</h1>
                </div>
                <div className='job-listings'>
                    {jobListingsOnCareersPage.map((job, index) => (
                        <div className={`job-card ${index % 2 === 0 ? 'gradient-2' : 'gradient-1'}`}
                            key={index}>
                            <div className="job-details">
                                <div className='title-location'>
                                    <h3>{job.title}</h3>
                                    <p>{job.location && `- ${job.location}`}</p>
                                </div>
                                <span>{job.country}</span>
                            </div>
                            <Link to={`/page-for-job-apply?jobTitle=${encodeURIComponent(job.title)}`} className="learn-more-btn">
                                <span>➕ Learn More</span>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
            {/* <JobApplicationForm /> */}
            <CommonInsuranceSection />
            <FooterSection />
        </div >
    )
}

export default CareersAndCulture
